import React from 'react';
import "./index.css";
import { PropertyHero } from './PropertyHero';
import { BrowseProperties } from './BrowseProperties';
import { StartYourProject } from '../Home/StartYourProject';
import { HowItWork } from '../Home/HowItWork';

export const Properties = () => {
  return (
    <div className='propertyContainer'>
        <PropertyHero/>
        <BrowseProperties/>
        <HowItWork/>
        <StartYourProject/>
    
    </div>
  )
}
